export default "__VITE_ASSET__BB_RJj$q__"